const $ = jQuery.noConflict();

class VideoBackground {
	constructor() {
		this.videoHero = $('.block-video-hero');
	}

	init() {
		if (!$('.block-video-hero').length) {
			return;
		}
		//console.log('runs');
		this.bindEvents();
	}

	bindEvents() {
		this.displayVideoBackground();
	}

	displayVideoBackground() {
		const videoUrl = this.videoHero.attr('data-video-url');

		if( videoUrl && window.outerWidth >= '768' ) {
			const cleanEmbedUrl = VideoBackground.swapVideoUrl(videoUrl);
			//console.log(cleanEmbedUrl);
			$('.block-video-hero__iframe').attr('src', (cleanEmbedUrl + '?autoplay=1&background=1&muted=1&loop=1&controls=0?title=0?sidedock=0'));
		}
	}

	static swapVideoUrl(videoSource) {
    let videoEmbed;
    if( videoSource.includes('youtu') ) {
      let ytRegExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/,
            match = videoSource.match(ytRegExp),
            src = match[2],
            videoEmbed = 'https://youtube.com/embed/' + src;
						return videoEmbed;
    } else {
			return videoSource
		}
  }
}
export default new VideoBackground();
